export enum TipoCorrecaoObraEnum {

  SemCorrecao = "Sem Correções",
  Parcial = "Retirado valor parcial da nota no abatimento",
  Total = "Retidado valor total da nota no abatimento",
  OK = "Nota Fiscal validada, sem necessidade de correção"
}
